import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import type { ReactNode } from 'react';

export type OrderSectionProps = {
  title: string;
  isLoading?: boolean;
  children: ReactNode;
};

export const OrderSection = (props: OrderSectionProps) => {
  return (
    <PageLayout title={props.title}>
      {props.isLoading && (
        <Stack alignItems="center" justifyContent="center" height="250px">
          <LoadingSpinner />
        </Stack>
      )}
      {!props.isLoading && (
        <>
          <Stack direction="row" justifyContent="end"></Stack>
          {props.children}
        </>
      )}
    </PageLayout>
  );
};
